import Login from "./pages/Login/Login";
import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import { SessionContext } from "./components/SessionContext";
import { useEffect, useState } from "react";
import Clock from "./components/clock";
import supabase from "./supabase";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing/Landing";
import ProductEdit from "./pages/Landing/ProductEdit";
import { ToastContainer } from "react-toastify";
import ProductNew from "./pages/Landing/ProductNew";
import Orders from "./pages/Landing/Orders";
import OrderDetail from "./pages/Landing/OrderDetail";
import Ratings from "./pages/Landing/Ratings";
import Banners from "./pages/Landing/Banners";
import Four0four from "./pages/404/404";
import WayBillStatus from "./pages/WayBillStatus/WayBillStatus";
import Statistics from "./pages/Statistics/Statistics";
import RenderShippingLabel from "./pages/Landing/ShippingLabel";
import Categories from "./pages/Landing/Categories";
import CreateInvoice from "./pages/Landing/CreateInvoice";
import CreatedInvoices from "./pages/Landing/CreatedInvoices";


function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        const role = session?.user?.app_metadata?.userrole || session?.user?.app_metadata?.role;
        if (role && role.toLowerCase() === "admin") {
          setSession(session);
        } else {
          supabase.auth.signOut();
          setSession(null);
        }
      }
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (_event === "SIGNED_OUT") {
        setSession(null);
      } else if (session) {
        const role = session?.user?.app_metadata?.userrole || session?.user?.app_metadata?.role;
        if (role && role.toLowerCase() === "admin") {
          setSession(session);
        } else {
          supabase.auth.signOut();
          setSession(null);
        }
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);



  if (loading) {
    return <Clock />;
  }

  return (
    <Provider store={store}>
      <SessionContext.Provider value={{ session, setSession }}>
        <Router>
          <ToastContainer />
          <Routes>
            <Route path="/" element={session ? <Landing /> : <Login />} />
            <Route
              path="/product/:productId"
              element={session ? <ProductEdit /> : <Login />}
            />
            <Route
              path="/addnew"
              element={session ? <ProductNew /> : <Login />}
            />
            <Route path="/orders" element={session ? <Orders /> : <Login />} />
            <Route
              path="/order/:order_id"
              element={session ? <OrderDetail /> : <Login />}
            />
            <Route
              path="/ratings"
              element={session ? <Ratings /> : <Login />}
            />
            <Route
              path="/banners"
              element={session ? <Banners /> : <Login />}
            />
            <Route
              path="/trackawbs"
              element={session ? <WayBillStatus /> : <Login />}
            />
            <Route
              path="/trackawbs/:awb"
              element={session ? <WayBillStatus /> : <Login />}
            />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/print" element={<RenderShippingLabel />} />
            <Route path="/categories" element={session ? <Categories /> : <Login />} />
            <Route path="/create-invoice" element={session ? <CreateInvoice /> : <Login />} />
            <Route path="/created-invoices" element={session ? <CreatedInvoices /> : <Login />} />

            <Route path="*" element={<Four0four />} />
          </Routes>
        </Router>
      </SessionContext.Provider>
    </Provider>
  );
}

export default App;
